export const LOADING = 'LOADING' as const;
export const PREVIEW = 'PREVIEW' as const;
export const COMPLETE = 'COMPLETE' as const;

export type IssueLoadingStage = typeof LOADING | typeof PREVIEW | typeof COMPLETE;
